import CrudCustom from '../../../libs/custom/CrudCustom';


let SandingAsetService = new CrudCustom('/sanding-aset-akuns');
export default SandingAsetService;
